<template>
  <section id="health-medication" class="card">
    <header class="card__head">
      <span class="step">3</span>
      <div>
        <strong>用药记录</strong>
        <p>记录处方药品、剂量和频次，自动计算依从性并生成提醒</p>
      </div>
      <em>{{ activeCount }}种药品服用中</em>
    </header>
    <div class="meds">
      <div class="meds__bar">
        <div class="chips">
          <span class="is-blue">今日服药 {{ member.medToday }}</span>
          <span class="is-green">近7日依从性 {{ member.medAdherence }}</span>
          <span class="is-amber">下次提醒 {{ member.medNext }}</span>
        </div>
        <button type="button" class="primary" @click="showForm = !showForm">
          {{ showForm ? '取消新增' : '+ 新增用药记录' }}
        </button>
      </div>

      <div v-if="showForm" class="med-form">
        <label>药品名称
          <input v-model="form.name" type="text" placeholder="请输入处方药品名称" />
        </label>
        <label>单次剂量
          <input v-model="form.dosage" type="text" placeholder="如：5mg" />
        </label>
        <label>服用频次
          <select v-model="form.frequency">
            <option>每日1次</option>
            <option>每日2次</option>
            <option>每日3次</option>
            <option>按需服用</option>
          </select>
        </label>
        <button type="button" class="primary" :disabled="saving" @click="submit">保存记录</button>
      </div>

      <div class="med-table">
        <div class="med-table__head">
          <span>药品名称</span>
          <span>剂量 / 频次</span>
          <span>服用周期</span>
          <span>依从性</span>
          <span>状态</span>
          <span>操作</span>
        </div>
        <div v-for="item in member.medications" :key="item.id" class="med-table__row">
          <div>
            <strong>{{ item.drugName }}</strong>
            <p v-if="item.prescriptionSyncFlag == 1">处方已同步</p>
            <p v-else>{{ item.spec || '' }}</p>
          </div>
          <span>{{ item.dosageFrequency || '--' }}</span>
          <span>{{ item.periodText || '--' }}</span>
          <div class="adhere">
            <strong>{{ item.adherenceRate == null ? '--' : item.adherenceRate + '%' }}</strong>
            <i><b :style="{ width: adhereWidth(item.adherenceRate) }"></b></i>
          </div>
          <span><em class="status" :class="item.status == 1 ? 'is-on' : 'is-off'">{{ item.statusText || '--' }}</em></span>
          <span class="ops">
            <button v-if="item.status == 1" type="button" @click="$emit('stop', item.id)">停药</button>
          </span>
        </div>
        <div v-if="!member.medications.length" class="med-empty">暂无用药记录，可通过处方同步或手动新增</div>
      </div>
    </div>
  </section>
</template>

<script>
/** 用药台账：新增表单在组件内，保存和停药交给页面提交 */
import { adhereWidth } from '../helpers';

export default {
  name: 'MedicationRecord',
  props: {
    member: { type: Object, required: true },
    activeCount: { type: Number, default: 0 },
    saving: { type: Boolean, default: false }
  },
  data() {
    return {
      showForm: false,
      form: { name: '', dosage: '', frequency: '每日1次' }
    };
  },
  methods: {
    adhereWidth,
    submit() {
      this.$emit('save', { ...this.form });
    },
    resetForm() {
      this.form = { name: '', dosage: '', frequency: '每日1次' };
      this.showForm = false;
    }
  }
};
</script>
